import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-bread-crumbs',
  templateUrl: './bread-crumbs.component.html',
  styleUrls: ['./bread-crumbs.component.scss']
})
export class BreadCrumbsComponent implements OnInit {

  @Input() breadCrumb: any = '';
  userId: String;
  constructor(private router: Router,
    private route: ActivatedRoute) {
    this.userId = this.route.snapshot.queryParams.userId;
  }

  ngOnInit() {
  }

  onClick(data) {
    if (data.navigate) {
      data.navigate();  // Call the navigate function if it exists
    } else if (data.route && this.userId) {
      this.router.navigate([data.route], { queryParams: { id: this.userId } });
    } else if (data.route && data.id) {
      this.router.navigate([data.route], { queryParams: { id: data.id } });
    } else if (data.route) {
      this.router.navigate([data.route]);
    }
  }
}
